import type { ApiResponse } from '@gangacars/shared';
import { announceDashboardChange } from './dashboardSync';

const API_BASE = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? '';
let csrfToken = '';

export class ApiClientError extends Error {
  constructor(public code: string, message: string, public status: number, public details?: unknown) { super(message); }
}

export const setCsrfToken = (token: string) => { csrfToken = token; };
export const assetUrl = (path: string | null | undefined) => path ? (path.startsWith('/api/') ? `${API_BASE}${path}` : path) : null;

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData)) headers.set('Content-Type', 'application/json');
  if (csrfToken && init.method && !['GET','HEAD'].includes(init.method)) headers.set('X-CSRF-Token', csrfToken);
  const response = await fetch(`${API_BASE}${path}`, { ...init, headers, credentials: 'include' });
  const payload = await response.json() as ApiResponse<T>;
  if (!payload.success) throw new ApiClientError(payload.error.code, payload.error.message, response.status, payload.error.details);
  if (path.startsWith('/api/admin/') && init.method && !['GET','HEAD'].includes(init.method)) announceDashboardChange();
  return payload.data;
}

export async function apiBlob(path: string): Promise<Blob> {
  const response = await fetch(`${API_BASE}${path}`, { credentials: 'include' });
  if (!response.ok) {
    const payload = await response.json().catch(() => null) as ApiResponse<unknown> | null;
    if (payload && !payload.success) throw new ApiClientError(payload.error.code, payload.error.message, response.status, payload.error.details);
    throw new ApiClientError('DOWNLOAD_FAILED', 'No se pudo descargar el archivo.', response.status);
  }
  return response.blob();
}

export async function apiPage<T>(path: string): Promise<{data:T;meta:{page:number;limit:number;total:number;pages:number}}> {
  const response = await fetch(`${API_BASE}${path}`, { credentials:'include' });
  const payload = await response.json() as ApiResponse<T>;
  if (!payload.success) throw new ApiClientError(payload.error.code,payload.error.message,response.status,payload.error.details);
  if (!payload.meta) throw new ApiClientError('INVALID_RESPONSE','Respuesta paginada incompleta.',500);
  return {data:payload.data,meta:payload.meta};
}
